import "@mobiscroll/react/dist/css/mobiscroll.min.css";
import { Select, snackbar } from "@mobiscroll/react5";
import axios from "axios";
import { useState } from "react";
import { Card } from "react-bootstrap";
import { useQuery } from "react-query";
import upload from "src/assets/upload.svg";
import Loader from "src/components/Dashboard/common/Loader";
import getFilenameFromS3Link from "src/lib/getFilenameFromS3Link";
import TncTextEditorPopup from "./TncTextEditorPopup";
import ContractTextEditorPopup from "./ContractTextEditorPopup";
import ViewPreviousTnC from "./ViewPreviousTnC";
import { getFileForClinic, getFileForDocg, uploadFileForClinic, uploadFileForDocg } from "./api";

function App() {
  const [loader, setLoader] = useState(false);

  const uploadFile = async (file, fileType, setFile) => {
    if (file) {
      setLoader(true);

      try {
        const ext = file.name.split(".").pop();
        const res = await uploadFileForDocg({ fileType, ext: ext });

        // Determine content type based on file extension
        const contentType = ext === 'html' ? 'text/html' : 'application/pdf';

        await axios.put(res.url, file, {
          headers: { "Content-Type": contentType, "Access-Control-Allow-Origin": "*", },
        });

        if (setFile) {
          setFile(null);
        }
        snackbar({ message: "File uploaded successfully", color: "success", });
        return true;

      } catch (error) {
        console.error("Error uploading file:", error);
        return false;
      } finally {
        setLoader(false);
      }
    } else {
      return false;
    }
  };

  const uploadFileClinic = async (file, fileType) => {
    if (file) {
      setLoader(true);

      try {
        const ext = file.name.split(".").pop();
        const res = await uploadFileForClinic(fileType, ext);

        const contentType = ext === 'html' ? 'text/html' : 'application/pdf';

        await axios.put(res.url, file, {
          headers: { "Content-Type": contentType, "Access-Control-Allow-Origin": "*", },
        });
        return true;

      } catch (error) {
        console.error("Error uploading file:", error);
        return false;
      } finally {
        setLoader(false);
      }
    } else {
      return false;
    }
  };

  return (
    <div title="Terms and Conditions" className="py-2 w-100">
      <Loader show={loader} />
      <Card className="docg-card">
        <Card.Header className="docg-card-header">
          <Card.Title className="docg-card-title d-flex align-items-center ">
            Templates
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="mbsc-row">
            <div className="mbsc-col-6">
              <TncCard
                uploadFile={uploadFile}
                list={[{ text: "Terms and Conditions", value: "TermsAndConditionsForApp", },]}
                title="App/Patient from DocG"
              />
            </div>
            <div className="mbsc-col-6">
              <TncCard
                uploadFile={uploadFile}
                list={[
                  { text: "Terms and Conditions", value: "TermsAndConditionsForClinic", },
                  { text: "Contract", value: "ClinicContract" },
                ]}
                title="Clinics from DocG"
              />
            </div>
          </div>
          <div className="mbsc-row mt-4">
            <div className="mbsc-col-6">
              <TncCard
                uploadFile={uploadFileClinic}
                list={[{ text: "Clinic Terms And Conditions for App", value: "ClinicTermsAndConditionsForApp", },]}
                title="From Clinics - App"
                type="clinic"
              />
            </div>
          </div>

          <div className="mbsc-col-6 mt-4"></div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default App;

const TncCard = ({ title, list, uploadFile, type }) => {
  const [uploaded_file, setFile] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [showTextEditor, setShowTextEditor] = useState(false);
  const [showContractEditor, setShowContractEditor] = useState(false);
  const [showPrevFile, setShowPrevFile] = useState(false);

  const handleTextEditorSave = async (file, fileType) => {
    const success = await uploadFile(file, fileType, null);
    if (success) {
      refetch();
    }
    return success;
  };

  const handleContractEditorSave = async (file, fileType) => {
    const success = await uploadFile(file, fileType, null);
    if (success) {
      refetch();
    }
    return success;
  };

  const openTextEditor = () => { setShowTextEditor(true); };
  const closeTextEditor = () => { setShowTextEditor(false); };
  const openContractEditor = () => { setShowContractEditor(true); };
  const closeContractEditor = () => { setShowContractEditor(false); };

  // Check if current fileType requires text editor
  const isClinicTncForApp = fileType === "ClinicTermsAndConditionsForApp";
  const isClinicContract = fileType === "ClinicContract";

  const { data: file_link, refetch, loading, } = useQuery(
    ["docg files", fileType, type], async function ({ queryKey }) {
      try {
        let res;
        if (type == "clinic") {
          res = await getFileForClinic(queryKey[1]);
        } else {
          res = await getFileForDocg(queryKey[1]);
        }
        return res?.url;
      } catch (err) {
        console.error(err);
        return null;
      }
    },
    {
      enabled: !!fileType,
    }
  );

  return (
    <Card className="docg-card">
      <Loader show={loading} />
      <Card.Header className="docg-card-header">
        <Card.Title className="docg-card-title d-flex align-items-center ">
          {title}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <div className="mbsc-row">
          <div className="mbsc-col-12">
            <Select
              value={fileType}
              data={list}
              placeholder="Please select"
              onChange={(e) => {
                setFileType(e.value);
                setFile(null);
              }}
            />
          </div>
          {
            fileType ? (
              <>
                <div className="mbsc-col-12 mbsc-row justify-content-center">
                  {isClinicTncForApp ? (
                    <>
                      <button className="docg-save-btn col-5 my-3" onClick={openTextEditor}>
                        <img src={upload} alt="" /> Create TnC
                      </button>

                      <button className="docg-save-btn docg-signup-upload col-5 ml-4 my-3">
                        <img src={upload} alt="" /> Upload PDF
                        <input
                          type="file"
                          accept="application/pdf"
                          style={{ display: "block" }}
                          onChange={(e) => { setFile(e.target.files[0]); }}
                          file={uploaded_file}
                        />
                      </button>

                    </>
                  ) : isClinicContract ? (
                    // Special case: Show text editor button for Clinic Contract
                    <div className="upload-btn purple-button">
                      <button
                        onClick={openContractEditor}
                        className="docg-save-btn"
                        style={{ display: "flex", alignItems: "center", gap: "8px", height: "1.5rem" }}
                      >
                        <img src={upload} alt="" />
                        Create Contract
                      </button>
                    </div>
                  ) : (
                    // Default case: Show regular file upload
                    <div className="docg-signup-upload col-12 col-md-6 col-lg-12 mb-2">
                      <div className="upload-btn purple-button">
                        <img src={upload} alt="" />
                        Upload File
                      </div>
                      <input
                        id="check-upload"
                        type="file"
                        accept="application/pdf"
                        style={{ display: "block" }}
                        onChange={(e) => {
                          setFile(e.target.files[0]);
                        }}
                        file={uploaded_file}
                      />
                    </div>
                  )}
                </div>
                {file_link && (
                  <>
                    <div className="mbsc-col-12 text-center align-items-center justify-content-center gap-4">
                      <a
                        style={{ textDecoration: "underline", color: "green", fontWeight: "500", cursor: "pointer" }}
                        disabled={!file_link}
                        onClick={() => setShowPrevFile(true)}
                      >
                        {getFilenameFromS3Link(file_link)}
                      </a>
                    </div>
                  </>
                )}
              </>
            ) : null
          }

          {uploaded_file ? (
            <>
              <div className="d-flex w-100 align-items-center justify-content-center">
                <button
                  onClick={async () => {
                    await uploadFile(uploaded_file, fileType, setFile);
                    refetch();
                  }}
                  className="docg-save-btn"
                >
                  Upload
                </button>
              </div>
            </>
          ) : null}
        </div>
      </Card.Body>

      {/* Text Editor Popup */}
      <TncTextEditorPopup
        show={showTextEditor}
        closePopup={closeTextEditor}
        onSave={handleTextEditorSave}
        fileType={fileType}
      />

      {/* Contract Text Editor Popup */}
      <ContractTextEditorPopup
        show={showContractEditor}
        closePopup={closeContractEditor}
        onSave={handleContractEditorSave}
        fileType={fileType}
      />

      <ViewPreviousTnC
        show={showPrevFile}
        onHide={() => setShowPrevFile(false)}
        templateUrl={file_link}
      />
    </Card>
  );
};
